import Reporte from './reporte'
import Grafico from './grafico'
function Factura (showRender, appState) {
  const routes = {}

  routes['/factura/grafico'] = () => <Grafico showRender={showRender} appState={appState} />
  routes['/factura/reporte'] = () => <Reporte showRender={showRender} appState={appState} />

  return routes
}
export default Factura
